export default "__VITE_ASSET__16e9addb__"